/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const ReviewIcon = /*#__PURE__*/ createSvgIcon(
  'ReviewIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M5.833 11.667h1.355a.861.861 0 00.604-.25L11.708 7.5a1.281 1.281 0 00.375-.896 1.03 1.03 0 00-.104-.448 1.726 1.726 0 00-.27-.406l-.75-.792a1.253 1.253 0 00-1.365-.281c-.16.063-.302.156-.427.281L5.25 8.875a.832.832 0 00-.25.604v1.354c0 .236.08.434.24.594.16.16.357.24.593.24zm.417-1.25v-.792l2.104-2.104.417.375.375.416-2.104 2.105H6.25zm2.52-2.521l.376.416-.792-.791.417.375zm.543 3.77h4.854c.236 0 .434-.08.594-.239.16-.16.24-.358.24-.594a.807.807 0 00-.24-.594.806.806 0 00-.594-.239h-3.188l-1.666 1.667zM5 15l-1.917 1.917c-.263.263-.566.322-.906.177-.34-.146-.51-.407-.51-.782V3.334c0-.458.163-.85.49-1.177.326-.326.718-.49 1.176-.49h13.334c.458 0 .85.164 1.177.49.326.327.49.719.49 1.177v10c0 .459-.164.851-.49 1.177-.327.327-.719.49-1.177.49H5zm-.708-1.667h12.375v-10H3.333v10.938l.959-.938z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default ReviewIcon;
